import { Avatar } from 'components/avatar/avatar.module';
import { MESSAGE_SENDER, MESSAGE_TYPE } from 'consts/enum';
import { getTime } from 'helpers/helpers';
import botAvatar from 'icons/botAvatar.svg';
import { downloadIcon } from 'icons/download.js';
import { ENGT_CHAT } from 'js/bot.model';
import { downloadFile, generate6DigitUUID } from '../../helpers/helpers';
import './messageWrapper.scss';

const cache = {};

export class MessageWrapper {
	constructor(props) {
		return this.init(props);
	}

	addDownloadData(mediaUrl, type) {
		const iconWrapper = document.createElement('span');
		iconWrapper.classList.add('engt-btn-icons');
		iconWrapper.style.height = '24px';
		iconWrapper.innerHTML = downloadIcon();
		iconWrapper.setAttribute('tabindex', 0);
		iconWrapper.onclick = () => downloadFile(mediaUrl, type);
		iconWrapper.addEventListener('keydown', (e) => ENGT_CHAT.get('onEnterPress')(iconWrapper.onclick));
		return iconWrapper;
	}

	addDownloadPdfData(mediaUrl) {
		const iconWrapper = document.createElement('a');
		iconWrapper.setAttribute('href', mediaUrl);
		iconWrapper.setAttribute('aria-label', 'download media button');
		iconWrapper.setAttribute('download', `media-${generate6DigitUUID()}.png`);
		iconWrapper.setAttribute('target', '_blank');
		iconWrapper.setAttribute('tabindex', 0);
		iconWrapper.classList.add('engt-btn-icons');
		iconWrapper.style.height = '24px';
		iconWrapper.innerHTML = downloadIcon();
		return iconWrapper;
	}

	init(data) {
		const { AGENT, BOT } = MESSAGE_SENDER;
		const {
			agent_avatar,
			timestamp,
			message,
			id,
			innerHTML,
			sender,
			style,
			download,
			downloadLink,
			message_id,
			agent_name,
		} = data;
		const configuredBotAvatar = ENGT_CHAT.get('config.bot_avatar_image_url');
		const avatarInstance = new Avatar({
			id: `avatar-${message_id || id}`,
			img: agent_avatar || configuredBotAvatar || botAvatar,
			size: '36px',
			altText: agent_avatar ? 'agent-avatar' : 'bot-avatar',
			title: [AGENT].indexOf(sender) > -1 ? agent_name : ENGT_CHAT.get('config.bot_name'),
		});

		const messageTxt = typeof message === 'string' ? message : message?.text || '';
		const wrapper = document.createElement('div');
		const timeValue = new Date(timestamp ? `${timestamp}` : new Date().toISOString());

		wrapper.id = message_id || id;
		wrapper.classList.add('engt-msg-container');
		wrapper.style.alignItems = 'flex-end';
		wrapper.setAttribute('data-message', messageTxt?.substring?.(0, 70)?.replaceAll?.('\n', ' '));
		wrapper.setAttribute('data-msg-clock-time', getTime(timeValue));
		wrapper.setAttribute('data-msg-sender', sender);
		if ([AGENT, BOT].indexOf(sender) > -1) {
			wrapper.innerHTML = avatarInstance.render();
		}
		wrapper.innerHTML += innerHTML;
		if (download && downloadLink) {
			if (message === MESSAGE_TYPE.IMAGE) {
				const downloadData = this.addDownloadData(downloadLink, 'png');
				wrapper.appendChild(downloadData);
			} else if (message === MESSAGE_TYPE.VIDEO) {
				const downloadData = this.addDownloadData(downloadLink, 'mp4');
				data?.platform && wrapper.appendChild(downloadData);
			} else if (message === MESSAGE_TYPE.AUDIO) {
				const downloadData = this.addDownloadData(downloadLink, 'mp3');
				wrapper.appendChild(downloadData);
			} else if (message === MESSAGE_TYPE.FILE) {
				const downloadData = this.addDownloadPdfData(downloadLink);
				wrapper.appendChild(downloadData);
			}
		}
		if (style) {
			wrapper.style = style;
		}

		return wrapper;
	}
}
